import * as types from "./types";

function obtenerListadoBajas(payload) {
  return { type: types.FETCH_LISTADO_BAJAS, payload };
}

function resetListadoBajas() {
  return { type: types.RESET_LISTADO_BAJAS };
}

/*---*/
export { obtenerListadoBajas, resetListadoBajas };



// WEBPACK FOOTER //
// ./src/ducks/listados/actions.js